import { computed } from "vue";
import { useCampaignBuiltComponents } from "../../composables";
import { RoleV3ComponentAdapter } from "./RoleV3ComponentAdapter";
export const useRoleV3BuiltComponents = (campaignId) => {
    const { builtComponents } = useCampaignBuiltComponents(campaignId);
    const roleV3BuiltComponents = computed(() => {
        const supportedTypes = ["role-v3", "role-v4", "role-v9.0"];
        const roleV3BuiltComponents = builtComponents.value.filter((component) => component.type !== null &&
            supportedTypes.includes(component.type));
        return roleV3BuiltComponents.map((component) => new RoleV3ComponentAdapter(component));
    });
    return {
        roleV3BuiltComponents,
    };
};
